import { API } from '../../api';
import { axiosInstance } from '../../utils/fetcher';

const CancelToken = axiosInstance.CancelToken;

let getRoutingGuideListEffectCancelToken = () => {};
export const getRoutingGuideVal = (params = {}) => {
  getRoutingGuideListEffectCancelToken();
  return axiosInstance.request({
    cancelToken: new CancelToken(function executor(c) {
      getRoutingGuideListEffectCancelToken = c;
    }),
    method: 'get',
    params,
    url: `${API.ROUTING_GUIDE}/GetRoutingGuideFromSearch`,
  });
};

let getRoutingGuideIdDataCancelToken = () => {};
export const getRoutingGuideIdData = (params = {}) => {
  getRoutingGuideIdDataCancelToken();
  return axiosInstance.request({
    cancelToken: new CancelToken(function executor(c) {
      getRoutingGuideIdDataCancelToken = c;
    }),
    method: 'get',
    params,
    url: `${API.ROUTING_GUIDE}/GetRoutingGuide`,
  });
};

// TODO
export const getCarrierServiceListEffect = (params = {}) => {
  return axiosInstance.request({
    method: 'get',
    params,
    url: `${API.ROUTING_GUIDE}/GetCarrierServiceList`,
  });
};

let createRoutingGuideEffectCancelToken = () => {};
export const createRoutingGuideEffect = (data) => {
  createRoutingGuideEffectCancelToken();
  return axiosInstance.request({
    cancelToken: new CancelToken(function executor(c) {
      createRoutingGuideEffectCancelToken = c;
    }),
    data,
    headers: { 'Content-Type': 'application/json' },
    method: 'post',
    url: `${API.ROUTING_GUIDE}/PostSaveRoutingHeader`,
  });
};

let createRoutingGuideUserEffectToken = () => {};
export const createRoutingGuideUserEffect = (data) => {
  createRoutingGuideUserEffectToken();
  return axiosInstance.request({
    cancelToken: new CancelToken(function executor(c) {
      createRoutingGuideUserEffectToken = c;
    }),
    data,
    headers: { 'Content-Type': 'application/json' },
    method: 'post',
    url: `${API.ROUTING_GUIDE}/PostAddUserDetails`,
  });
};

let deleteRoutingGuidesEffectToken = () => {};
export const deleteRoutingGuidesEffect = (params) => {
  deleteRoutingGuidesEffectToken();
  return axiosInstance.request({
    cancelToken: new CancelToken(function executor(c) {
      deleteRoutingGuidesEffectToken = c;
    }),
    data: params,
    method: 'delete',
    url: `${API.ROUTING_GUIDE}/DeleteRoutingGuideHeader`,
  });
};

let checkNXPUserEffectCancelToken = () => {};
export const checkNXPUserEffect = () => {
  checkNXPUserEffectCancelToken();
  return axiosInstance.request({
    cancelToken: new CancelToken(function executor(c) {
      checkNXPUserEffectCancelToken = c;
    }),
    method: 'get',
    url: `${API.ROUTING_GUIDE}/GetUserValidationforNXP`,
  });
};

let getDownloadRoutingGuideExcelEffectToken = () => {};
export const getDownloadRoutingGuideExcelEffect = (params) => {
  getDownloadRoutingGuideExcelEffectToken();
  return axiosInstance.request({
    cancelToken: new CancelToken(function executor(c) {
      getDownloadRoutingGuideExcelEffectToken = c;
    }),
    method: 'get',
    params,
    url: `${API.ROUTING_GUIDE}/GetDownloadRoutingGuideExcel`,
  });
};

export const getDownloadRoutingGuideExcelTemplateEffect = ({ customerKey }) => {
  return axiosInstance.request({
    method: 'get',
    params: { customerKey },
    url: `${API.ROUTING_GUIDE}/GetDownloadRoutingGuideExcelTemplate`,
  });
};

export const updateRoutingGuideTransportEffect = (data) => {
  return axiosInstance.request({
    data: data.routingDetail,
    headers: { 'Content-Type': 'application/json' },
    method: 'post',
    url: `${API.ROUTING_GUIDE}/PostSaveRoutingDetails`,
  });
};

let routingGuideFileUploadEffectToken = () => {};
export const routingGuideFileUploadEffect = (data) => {
  routingGuideFileUploadEffectToken();
  return axiosInstance.request({
    cancelToken: new CancelToken(function executor(c) {
      routingGuideFileUploadEffectToken = c;
    }),
    data,
    headers: { 'Content-Type': 'multipart/form-data' },
    method: 'post',
    url: `${API.ROUTING_GUIDE}/PostUploadRoutingGuideExcel`,
  });
};

let getContentNXPRoutingGuideEffectToken = () => {};
export const getContentNXPRoutingGuideEffect = () => {
  getContentNXPRoutingGuideEffectToken();
  return axiosInstance.request({
    cancelToken: new CancelToken(function executor(c) {
      getContentNXPRoutingGuideEffectToken = c;
    }),
    method: 'get',
    url: `${API.ROUTING_GUIDE}/GetDashboardContent`,
  });
};

let updateContentNXPRoutingGuideEffectToken = () => {};
export const updateContentNXPRoutingGuideEffect = (data) => {
  updateContentNXPRoutingGuideEffectToken();
  return axiosInstance.request({
    cancelToken: new CancelToken(function executor(c) {
      updateContentNXPRoutingGuideEffectToken = c;
    }),
    data,
    headers: { 'Content-Type': 'application/json' },
    method: 'post',
    url: `${API.ROUTING_GUIDE}/PostSaveRoutingGuideContent`,
  });
};

export const getNXPUserTypesEffect = () => {
  return axiosInstance.request({
    method: 'get',
    url: `${API.ROUTING_GUIDE}/GetUserTypes`,
  });
};

let getNXPClientCodeEffectToken = () => {};
export const getNXPClientCodeEffect = () => {
  getNXPClientCodeEffectToken();
  return axiosInstance.request({
    cancelToken: new CancelToken(function executor(c) {
      getNXPClientCodeEffectToken = c;
    }),
    method: 'get',
    url: `${API.ROUTING_GUIDE}/GetClientCode`,
  });
};

let getNXPUserSearchListEffectToken = () => {};
export const getNXPUserSearchListEffect = (params) => {
  getNXPUserSearchListEffectToken();
  return axiosInstance.request({
    cancelToken: new CancelToken(function executor(c) {
      getNXPUserSearchListEffectToken = c;
    }),
    method: 'get',
    params,
    url: `${API.ROUTING_GUIDE}/GetUserSearchResult`,
  });
};

let deleteRoutingUserEffectToken = () => {};
export const deleteRoutingUserEffect = (params) => {
  deleteRoutingUserEffectToken();
  return axiosInstance.request({
    cancelToken: new CancelToken(function executor(c) {
      deleteRoutingUserEffectToken = c;
    }),
    data: params,
    method: 'delete',
    url: `${API.ROUTING_GUIDE}/DeleteRoutingUser`,
  });
};

let postSaveFileEffectToken = () => {};
export const postSaveFileEffect = (data) => {
  postSaveFileEffectToken();
  return axiosInstance.request({
    cancelToken: new CancelToken(function executor(c) {
      postSaveFileEffectToken = c;
    }),
    data,
    headers: { 'Content-Type': 'multipart/form-data' },
    method: 'post',
    url: `${API.ROUTING_GUIDE}/PostSaveFile`,
  });
};

export const deleteRoutingGuideTransportationDetailsEffect = (params) => {
  return axiosInstance.request({
    method: 'delete',
    params,
    url: `${API.ROUTING_GUIDE}/DeleteRoutingGuideTrasportationDetails`,
  });
};

export const postSaveRoutingAccessorialDetailsEffects = (data) => {
  return axiosInstance.request({
    data,
    method: 'post',
    url: `${API.ROUTING_GUIDE}/SaveRoutingAccessorialDetails`,
  });
};

export const deleteRoutingGuideAccessorialEffect = (params) => {
  return axiosInstance.request({
    method: 'delete',
    params,
    url: `${API.ROUTING_GUIDE}/DeleteRoutingGuideAccessorial`,
  });
};

export const getRoutingGuideCarriersEffect = (params) => {
  return axiosInstance.request({
    method: 'get',
    url: `${API.SPOT_QUOTE_ROUTING_GUIDE_V2}/${params?.routingGuideId}/carriers`,
  });
};

export const getRoutingGuideCollaboratorsEffect = (params) => {
  return axiosInstance.request({
    method: 'get',
    url: `${API.SPOT_QUOTE_ROUTING_GUIDE_V2}/${params?.routingGuideId}/collaborators`,
  });
};

export const editRoutingGuideCarrierEffect = (data) => {
  return axiosInstance.request({
    data,
    method: 'put',
    url: `${API.SPOT_QUOTE_ROUTING_GUIDE_V2}/${data?.routingGuideId}/carriers`,
  });
};

export const editRoutingGuideCollaboratorEffect = (data) => {
  return axiosInstance.request({
    data,
    method: 'put',
    url: `${API.SPOT_QUOTE_ROUTING_GUIDE_V2}/${data?.routingGuideId}/collaborators`,
  });
};

export const addRoutingGuideCarrierEffect = (data) => {
  return axiosInstance.request({
    data,
    method: 'patch',
    url: `${API.SPOT_QUOTE_ROUTING_GUIDE_V2}/${data?.routingGuideId}/carriers`,
  });
};

export const addRoutingGuideCollaboratorEffect = (data) => {
  return axiosInstance.request({
    data,
    method: 'patch',
    url: `${API.SPOT_QUOTE_ROUTING_GUIDE_V2}/${data?.routingGuideId}/collaborators`,
  });
};

export const deleteRoutingGuideCarrierEffect = (data) => {
  return axiosInstance.request({
    data,
    method: 'delete',
    url: `${API.SPOT_QUOTE_ROUTING_GUIDE_V2}/${data?.routingGuideId}/carriers/${data?.carrierId}`,
  });
};

export const deleteRoutingGuideCollaboratorEffect = (data) => {
  return axiosInstance.request({
    data,
    method: 'delete',
    url: `${API.SPOT_QUOTE_ROUTING_GUIDE_V2}/${data?.routingGuideId}/collaborators/${data?.collaboratorId}`,
  });
};

export const getFilteredGuidesEffect = (params) => {
  return axiosInstance.request({
    method: 'get',
    params,
    url: `${API.SPOT_QUOTE_ROUTING_GUIDE_V2}/search`,
  });
};

export const getExtendedCarrierAndBidDataEffect = (params) => {
  return axiosInstance.request({
    method: 'get',
    params,
    url: `${API.SPOT_QUOTE_ROUTING_GUIDE_V2}/carriers/extended`,
  });
};

export const getAllUsersNameEffect = (params) => {
  return axiosInstance.request({
    method: 'get',
    params,
    url: `${API.BASE_IDENTITY}/users/$search-by-selected-company`,
  });
};
